import React, { FC } from 'react';
import IngkaTooltip from '../IngkaTooltip';
import Button from '@ingka/button';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import CloudDown from '@ingka/ssr-icon/paths/arrow-cloud-out';

const ExportTableButton: FC = () => {
  const apiRef = useGridApiContext();

  return (
    <IngkaTooltip label={'Export Excel'}>
      <Button
        iconOnly
        size={'small'}
        type={'secondary'}
        onClick={() => apiRef.current.exportDataAsExcel()}
        ssrIcon={CloudDown}
      />
    </IngkaTooltip>
  );
};

export default ExportTableButton;
